<template>
	<div>
		<HeaderComponent></HeaderComponent>
		<FeaturesComponent></FeaturesComponent>
		<EventsComponent></EventsComponent>
		<SignUpComponent></SignUpComponent>
		<LogoComponent></LogoComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import HeaderComponent from '@/components/Home/HeaderComponent'
	import FeaturesComponent from '@/components/Home/FeaturesComponent'
	import EventsComponent from '@/components/Home/EventsComponent'
	import SignUpComponent from '@/components/Home/SignUpComponent'
	import LogoComponent from '@/components/Home/LogoComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			HeaderComponent,
			FeaturesComponent,
			EventsComponent,
			SignUpComponent,
			LogoComponent,
			ContactComponent,
			PartnersComponent
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue